import React, { useState } from "react";
import product4 from "../assets/products/product4.png";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const ExchangeProduct = () => {
  const [selectedSize, setSelectedSize] = useState("XS");
  const [reason, setReason] = useState("");
  const [confirmed, setConfirmed] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { product, subProduct, order } = location.state || {};

  const sizes = ["XS", "S", "M", "L", "XL"];

  return (
    <div className="max-w-6xl mx-auto px-4 py-6 space-y-6 text-sm text-gray-700 font-[Inter,sans-serif]">
      {/* Top Nav */}
      <div className="flex items-center gap-3 text-gray-800 mb-4">
        <button
          onClick={() => navigate(-1)}
          className="p-2 rounded-full bg-white shadow-sm hover:bg-purple-100 hover:text-purple-700 transition-all"
        >
          <ArrowLeft size={20} />
        </button>
        <span className="text-lg font-extrabold">Replacement Detail</span>
      </div>

      {/* Product Summary */}
      <div className="flex items-start gap-4 bg-[#f8f8f8] p-4 rounded-md shadow-sm">
        <img
          loading="lazy"
          src={subProduct?.sub_pro_img ?? product4}
          alt={product?.product_name}
          className="w-22 h-28 object-cover rounded-md border"
        />
        <div>
          <p className="font-semibold">{product?.product_name}</p>
          <p className="text-gray-500">{product?.category_name}</p>
          <p className="text-gray-500 text-sm">Color: {subProduct?.color}</p>
          <p className="text-gray-500 text-sm">Size: {subProduct?.size}</p>
          <p className="text-black font-bold mt-1">
            {subProduct?.customer_product_price} ₹
          </p>
        </div>
      </div>

      {/* Eligibility */}
      <div className="flex justify-between items-center bg-[#e7f6ec] border border-green-300 text-green-700 p-3 rounded-md">
        <div className="flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="44"
            height="45"
            viewBox="0 0 44 45"
            fill="none"
          >
            <rect
              x="1.7049"
              y="1.7674"
              width="41.4537"
              height="41.4537"
              rx="20.7269"
              fill="#EBEBEB"
            />
            <rect
              x="1.7049"
              y="1.7674"
              width="41.4537"
              height="41.4537"
              rx="20.7269"
              stroke="#028D25"
              stroke-width="1.5902"
            />
            <mask
              id="mask0_1395_16825"
              maskUnits="userSpaceOnUse"
              x="9"
              y="9"
              width="26"
              height="27"
            >
              <rect
                x="9.67383"
                y="9.73828"
                width="25.2655"
                height="25.2655"
                fill="#D9D9D9"
              />
            </mask>
            <g mask="url(#mask0_1395_16825)">
              <path
                d="M22.3105 27.8497L14.9414 20.4806V25.2968H12.8359V16.875H21.2578V18.9805H16.4152L22.3105 24.8757L30.3112 16.875L31.7851 18.3751L22.3105 27.8497Z"
                fill="#028D25"
              />
            </g>
          </svg>
          <span className=" font-medium">
            Eligibility For exchange till 17 May
          </span>
        </div>
        <Link
          to="/return-and-refund-policy"
          className="text-pink-600 text-xs font-semibold"
        >
          VIEW POLICY
        </Link>
      </div>

      {/* Replacement Size */}
      <div className="bg-[#f8f8f8] p-4 rounded-md shadow-sm">
        <div className="flex justify-between items-center mb-1">
          <p className="font-semibold text-sm">Select Replacement Size</p>
          <Link
            to="/return-and-refund-policy"
            className="text-pink-600 text-xs font-semibold"
          >
            VIEW POLICY
          </Link>
        </div>
        <p className="text-xs text-gray-500 mb-4">Original Size L</p>
        <div className="flex gap-2 mb-4">
          {sizes.map((size) => (
            <button
              key={size}
              onClick={() => setSelectedSize(size)}
              className={`w-10 h-10 rounded-full border text-sm font-semibold transition ${
                selectedSize === size
                  ? "bg-black text-white border-black"
                  : "border-gray-300 text-black hover:bg-black hover:text-white hover:border-black"
              }`}
            >
              {size}
            </button>
          ))}
        </div>
        <hr className="my-3" />
        <p className="text-sm">
          For any concerns, please contact customer care{" "}
          <button className="text-pink-600 font-semibold">CUSTOMER CARE</button>
        </p>
      </div>

      {/* Exchange Reason */}
      <div className="bg-[#f8f8f8] p-4 rounded-md shadow-sm">
        <p className="font-semibold mb-1 text-sm">Why are you exchanging it?</p>
        <p className="text-xs text-gray-500 mb-4">
          Please choose the correct reason for the return. This information is
          used only to improve our service.
        </p>
        <div className="space-y-3">
          <label className="flex gap-2 items-center">
            <input
              type="radio"
              name="reason"
              value="fit"
              checked={reason === "fit"}
              onChange={(e) => setReason(e.target.value)}
              className="accent-pink-600"
            />
            <span>Size or fit issues</span>
          </label>
          <label className="flex gap-2 items-center">
            <input
              type="radio"
              name="reason"
              value="defective"
              checked={reason === "defective"}
              onChange={(e) => setReason(e.target.value)}
              className="accent-pink-600"
            />
            <span>Receive a wrong or defective product</span>
          </label>
        </div>
      </div>

      {/* Confirmation */}
      <div className="bg-[#f8f8f8] p-4 rounded-md shadow-sm">
        <label className="flex items-start gap-3">
          <input
            type="checkbox"
            checked={confirmed}
            onChange={(e) => setConfirmed(e.target.checked)}
            className="mt-1 accent-pink-600"
          />
          <span className="text-sm">
            I confirm that the product is unused with the original tags intact.
          </span>
        </label>
      </div>

      {/* Submit */}
      <button
        disabled={!reason || !confirmed}
        className={`w-full py-3 rounded-md font-medium text-white font-semibold transition ${
          !reason || !confirmed
            ? "bg-[#FAD2D2] cursor-not-allowed"
            : "position: relative; bg-[#bb7070] hover:bg-[#a65c5c]"
        }`}
      >
        SELECT ADDRESS
      </button>
    </div>
  );
};

export default ExchangeProduct;
